import { jsPDF } from "jspdf";
import { logoBase64 } from "@/utils/reusables/pdfLogo";
import reusableBase from "@/utils/composables/format";

export default function pdfGenerateHandler() {
  const { dateFormatMonthDateYear } = reusableBase();
  const exportPDF = (item) => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 20;

    // ================= HEADER =================
    const addHeader = () => {
      const logoWidth = 120;
      const logoHeight = 30;
      const logoX = (pageWidth - logoWidth) / 2;

      doc.addImage(logoBase64, "JPEG", logoX, 10, logoWidth, logoHeight);

      let y = 38;

      doc.setFont("Times", "normal");
      doc.setFontSize(11); // slightly bigger for header lines

      const headerLines = [
        "14th Floor Manila Astral Tower, Taft Ave., cor. Padre Faura, Ermita, Manila 1000",
        "Telephone Nos.: (02) 8528-0480;",
        "Mobile Nos: 0922-822-1033 to 35; 0917-8518645; 0998-5869439",
        "Email Address: customerservices@iwc.com.ph",
      ];

      headerLines.forEach((line) => {
        doc.text(line, pageWidth / 2, y, { align: "center" });
        y += 6; // extra spacing for wider look
      });

      // Title
      doc.setFont("Times", "bold");
      doc.setFontSize(14); // bigger title
      doc.text("LETTER OF APPROVAL", pageWidth / 2, y + 12, {
        align: "center",
      });
    };

    // ================= DETAILS (Two Column) =================
    const addDetails = () => {
      let y = 100;
      const labelX = marginX;
      const valueX = marginX + 40;
      const maxWidth = pageWidth - valueX - marginX; // max width for value column

      doc.setFont("Times", "normal");
      doc.setFontSize(11);

      const rows = [
        ["Name of Provider", item.provider_name],
        ["IWC Card Number", item.iwccardno],
        ["Name of Cardholder", item.membername],
        ["Approval Number", item.approvalno],
        ["Date", dateFormatMonthDateYear(item.admit_date)],
      ];

      rows.forEach(([label, value]) => {
        doc.text(label, labelX, y);

        doc.setFont("Times", "normal");

        // Split long text into multiple lines to fit within maxWidth
        const lines = doc.splitTextToSize(value, maxWidth);
        doc.text(lines, valueX, y);

        doc.setFont("Times", "normal");

        // Increase y based on number of lines
        y += lines.length * 6 + 2; // 6mm per line, plus small gap
      });

      // Divider
      doc.setLineWidth(0.5);
      doc.line(marginX, y + 2, pageWidth - marginX, y + 2);

      return y + 12;
    };

    // ================= CONSULTATION =================
    const addConsultation = (startY) => {
      let y = startY;

      const pageWidth = doc.internal.pageSize.getWidth();
      const rightMargin = 20; // distance from the right edge

      // --- Header ---
      doc.setFont("Times", "bold");
      doc.setFontSize(11);
      doc.text("CONSULTATION", marginX, y);

      y += 6;

      // --- Details ---
      doc.setFont("Times", "normal");
      doc.text(item.provider_pf_category, marginX + 5, y);

      // Amount aligned to right
      const amountText = "";
      const textWidth = doc.getTextWidth(amountText);
      doc.text(amountText, pageWidth - rightMargin - textWidth, y);

      return y + 20;
    };

    // ================= VALIDITY NOTE =================
    const addValidityNote = (startY) => {
      let y = startY;

      doc.setFontSize(10);
      doc.setTextColor(120, 120, 120);

      doc.text("This letter of approval is ", marginX, y);

      const textWidth = doc.getTextWidth("This letter of approval is ");
      doc.setTextColor(255, 0, 0);
      doc.text("valid for three (3) days", marginX + textWidth, y);

      doc.setTextColor(120, 120, 120);
      const afterWidth = doc.getTextWidth("valid for three (3) days");
      doc.text(
        " from the date of issuance.",
        marginX + textWidth + afterWidth,
        y
      );

      y += 6;

      doc.text(
        "If not availed within three (3) days, it shall be considered void.",
        marginX,
        y
      );

      doc.setTextColor(0, 0, 0);
    };

    // ================= FOOTER =================
    const addFooter = () => {
      doc.setFontSize(9);
      doc.text(
        `Valid until: ${dateFormatMonthDateYear(item.date_validity)}`,
        marginX,
        pageHeight - 10
      );

      doc.text(`Page 1 of 1`, pageWidth - marginX, pageHeight - 10, {
        align: "right",
      });
    };

    // ================= GENERATE =================
    addHeader();
    const afterDetailsY = addDetails();
    const afterConsultY = addConsultation(afterDetailsY);
    addValidityNote(afterConsultY);
    addFooter();

    doc.save(`LOA_${item.approvalno}.pdf`);

    console.log("Download It");
  };

  return { exportPDF, dateFormatMonthDateYear };
}
